import axiosInstance from "../axiosInstance";

export const lotService = {
  fetchByInventory: async (inventoryId, page = 0, limit = 5, signal) => {
    try {
      const response = await axiosInstance.get(
        `/lot?inventory=${inventoryId}&$sort[date]=-1&$limit=${limit}&$skip=${page * limit}`,
        signal ? { signal } : undefined,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
